export const uploadControllers = new Map();

export const setUploadController = (tempId, controller) => {
  uploadControllers.set(tempId, controller);
};

export const abortUpload = (tempId) => {
  const controller = uploadControllers.get(tempId);

  if (controller) {
    controller.abort();
    uploadControllers.delete(tempId);
  }
};

export const clearUploadController = (tempId) => {
  uploadControllers.delete(tempId);
};

export const abortAllUploads = () => {
  uploadControllers.forEach((controller) => controller.abort());
  uploadControllers.clear();
};

// ---- Folder upload controller (single active upload at a time) ----
let folderUploadController = null;

export const setFolderUploadController = (controller) => {
  folderUploadController = controller;
};

export const abortFolderUpload = () => {
  if (folderUploadController) {
    folderUploadController.abort();
    folderUploadController = null;
  }
};

export const clearFolderUploadController = () => {
  folderUploadController = null;
};

// ---- Logout flag (lets beforeunload guards skip the "Leave site?" prompt) ----
let logoutInProgress = false;

export const setLogoutInProgress = (value) => {
  logoutInProgress = Boolean(value);
};

export const isLogoutInProgress = () => logoutInProgress;